import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as fsEntry from '../fs-entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: fsEntry.RESOURCE.payload.dimension.partialId,
      partialId: fsEntry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Amount associated with this financial statement record',
    isOptional: true,
    name: 'Amount',
    partialId: PartialId.Standard.create('amount'),
    type: core.common.value.types.Intrinsic.Currency,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
